import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxNciDictionaryItem } from "./dx-nci-dictionary-item";
let DxNciDictionary = class DxNciDictionary {
    constructor() {
        this._isHierarchical = false;
        this._elements = [];
        this._elementIndex = new Map();
        this._searchString = '';
    }
    fillIndex() {
        if (!this.isEmpty) {
            const names = [];
            this._elements.forEach(item => {
                this._elementIndex.set(item.id, item);
                names.push(item.name);
            });
            this._searchString = names.join(', ');
        }
    }
    addItem(item) {
        this._elements.push(item);
        this._elementIndex.set(item.id, item);
    }
    get elementIndex() {
        return this._elementIndex;
    }
    get isEmpty() {
        return !(this._elements && this._elements.length > 0);
    }
    get searchString() {
        return this._searchString;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get isHierarchical() {
        return this._isHierarchical;
    }
    set isHierarchical(value) {
        this._isHierarchical = value;
    }
    get sortField() {
        return this._sortField;
    }
    set sortField(value) {
        this._sortField = value;
    }
    get elements() {
        return this._elements;
    }
    set elements(value) {
        this._elements = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxNciDictionary.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNciDictionary.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNciDictionary.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "hierarchical", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxNciDictionary.prototype, "_isHierarchical", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sortField", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNciDictionary.prototype, "_sortField", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxNciDictionaryItem, { name: "elements", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxNciDictionary.prototype, "_elements", void 0);
DxNciDictionary = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [])
], DxNciDictionary);
export { DxNciDictionary };
